import React from 'react';
import { Outlet } from 'react-router-dom';
import EnterpriseProvider from '../../../../../Enterprise/providers/Enterprise';

const EnterprisesRouter: React.FC = () => (
  <EnterpriseProvider>
    <Outlet />
  </EnterpriseProvider>
);

export default EnterprisesRouter;
